import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SuporteAiLoaderService {
    private static readonly SCRIPT_ID = "iatec-suporte-ai-script";
    private loaded = false;

    /**
     * Injeta o bundle ES module do widget a partir da URL informada (obtida do backend,
     * coluna Url_api_suporte_ai_token). Anti-duplicação: flag em memória + verificação no DOM.
     * Não faz nada se a URL for vazia. (Req 1.1, 1.2)
     */
    load(src: string): void {
        if (!src || src.trim().length === 0) {
            return;
        }
        if (this.loaded || document.getElementById(SuporteAiLoaderService.SCRIPT_ID)) {
            this.loaded = true;
            return;
        }
        const script = document.createElement("script");
        script.type = "module"; // Req 1.1
        script.id = SuporteAiLoaderService.SCRIPT_ID;
        script.src = src; // Req 1.1 — URL vinda do backend, não fixa
        document.head.appendChild(script);
        this.loaded = true;
    }
}